import React, { useState } from 'react';
import { subscriptionFormatedDate } from './utils';
import { subscriptionService } from '../../_services';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const PlanCard = ({plan, selectedPlan, setSelectedPlan, activePlan, upcomingPlan, setUpcomingPlan, subscriptionInfo, setSubscriptionInfo, reactivateSubscription, cancelSubscription, timezone}) => {
  
  const history = useHistory()


  const handlePlanSelect = (planId, planName) => {
    setSelectedPlan(planId);
    console.log(`Selected ${planName} plan`);
  };

  const selectStyle = 'tw-bg-primary tw-text-white tw-hover:tw-bg-[#475569] tw-border-primary'
  const altStyle1 = 'tw-border-[#94BA33] tw-text-[#94BA33] tw-bg-white'
  const altStyle2 = 'tw-border-[#94BA33] tw-bg-[#94BA33] tw-text-white'

  let issueStyle = altStyle1 // 'tw-border-red-500 tw-bg-white tw-text-red-500'
  const isIssueStatus = subscriptionInfo?.status == 'Grace Period' || subscriptionInfo?.status == 'Cancelled'

  // switch(subscriptionInfo?.status) {
  //   case 'Cancelled':
  //     issueStyle = 'tw-border-[#94BA33] tw-text-[#94BA33] tw-bg-white'
  //     break
  //   case 'Grace Period':
  //     issueStyle = 'tw-bg-[#FF9D00] tw-text-white'
  //     break
  // }

  const activePlanExist = activePlan != undefined && activePlan != "none" && activePlan != 'grandfathered'
  const isActive = activePlanExist && activePlan == plan.subscriptionId
  const isSelected = selectedPlan === plan.subscriptionId
  const isUpcoming = upcomingPlan === plan.subscriptionId

  const reactivateSubscriptionAction = async () => {
    const res = await subscriptionService.updateSubscription(subscriptionInfo.planId, 'reactivate')
    if(res.status) {
      toast.success(res.message)
      setSubscriptionInfo(res.data)
    } else {
      toast.error(res.message)
    }
   
  }

  const cancelSubscriptionAction = async () => {
    const res = await subscriptionService.updateSubscription(subscriptionInfo.planId, 'cancel')
    if(res.status) {
      setSubscriptionInfo(res.data)
      toast.success(res.message)
    } else {
      toast.error(res.message)
    }
  }

  const managePaymentAction = async () => {
    history.push('/subscription/manage-payment')
  }

  const cancelSubscriptionUpcomingAction = async () => {
    const res = await subscriptionService.updateSubscription(subscriptionInfo.upcomingPlan, 'cancel')
    if(res.status) {
      setSubscriptionInfo(res.data)
      toast.success(res.message)
    } else {
      toast.error(res.message)
    }
  }

  const buttonText = isActive ? (subscriptionInfo?.status ?? 'Active')
    : isUpcoming ? 'Upcoming'
    : isSelected ? 'Selected'
    : (activePlanExist ? 'Change Plan' : 'Select')

  
  const additionalActionRow = () => {
    let isEmpty = false
    let text = ''
    let additionalActionText = ''
    let action = () => {}

    const processingText = "Payment processing in progress. "
    const cancelledText = `Your subscription has been canceled. `

    const dateText = subscriptionFormatedDate(subscriptionInfo?.nextRenewDate, timezone)
    const endOfGracePeriodText = subscriptionInfo?.endOfGracePeriod ? subscriptionFormatedDate(subscriptionInfo?.endOfGracePeriod, timezone) : null

    const cancelSubscriptionText = 'Cancel subscription.'
    const reactivateSubscriptionText = 'Reactivate subscription.'

    const managePaymentText = 'Manage Payment Method'

    const isProcessing = subscriptionInfo?.processing
    const isCancelled = subscriptionInfo?.status == 'Cancelled'
    const isGracePeriod = subscriptionInfo?.status == 'Grace Period'
    const cancelOnNextRenew = subscriptionInfo?.cancelOnNextRenew ?? false

    if(isActive) {
      if(isProcessing) {
        text = processingText
      } else if(isCancelled) {
        text = cancelledText
        additionalActionText = reactivateSubscriptionText
        action = reactivateSubscriptionAction
      } else if(isGracePeriod) {
        text = `Your subscription is in a grace period due to a failed payment. `
        additionalActionText = managePaymentText
        action = managePaymentAction
      } else if(cancelOnNextRenew) {
        text = `Your subscription ends on ${dateText}. `
        additionalActionText = reactivateSubscriptionText
        action = reactivateSubscriptionAction
      } else {
        text = `Your subscription renews on ${dateText}. `
        additionalActionText = cancelSubscriptionText
        action = cancelSubscriptionAction
      }
    } else if (isUpcoming) {
      if(subscriptionInfo?.processing) {
        text = processingText
      } else {
        text = subscriptionInfo?.nextRenewDate ? `Your subscription starts on ${dateText}. ` : `Your subscription starts on next renew. `
      }
      additionalActionText = cancelSubscriptionText
      action = cancelSubscriptionUpcomingAction
    } else {
      isEmpty = true
    }

    if(subscriptionInfo?.processing) {
      action = () => {}
      additionalActionText = ''
    }

    if(isEmpty) {
      return <></>
    } else {
      return <div className={`${isIssueStatus ? 'tw-text-red-500' : ''}`}>
        {text}
         <span
            onClick={action}
            className={`tw-underline tw-h-fit tw-cursor-pointer`}
          >
              {additionalActionText}
          </span>
      </div>
    }
  }


  return (
    <div key={plan.subscriptionId} className="tw-rounded-2xl tw-relative tw-flex tw-flex-col tw-h-full tw-border-solid tw-border tw-border-[#C7C7C7] tw-overflow-hidden">
      {plan.badge && (
        <div className="tw-flex tw-w-full tw-justify-center tw-h-[28px] tw-items-center tw-content-center">
          <span className="tw-text-center tw-flex tw-bg-primary tw-h-full tw-w-full tw-text-white tw-px-4 tw-py-1 tw-text-xs tw-font-medium tw-uppercase tw-justify-center tw-items-center tw-content-center">
            {plan.badge}
          </span>
        </div>
      )}
      <div className={`tw-text-center ${plan.badge ? 'tw-mt-[38px]' : 'tw-mt-[66px]'} tw-justify-between tw-flex-1 tw-flex tw-flex-col tw-px-[18px] `}>
        <div>
          <h3 className="tw-text-4xl tw-font-semibold tw-text-primary">
            {plan.name}
          </h3>
          <p className="tw-font-medium tw-text-black tw-text-base">
            {plan.description}
          </p>
        </div>
        
        <div className="tw-mb-4 tw-mt-8">
          <span className="tw-text-5xl tw-text-[#94BA33]" style={{
            fontSize: 54
          }}>
            ${plan.price}
          </span>
          <p className="tw-text-[#1a1a1a] tw-text-sm tw-mt-1">
            {plan.billing}
          </p>
        </div>
        
        {plan.savings && (
          <div className="tw-mb-6">
            <span className="tw-bg-[#94BA33] tw-text-white tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium">
              {plan.savings}
            </span>
          </div>
        )}
        
        <div className='tw-pb-5 tw-mt-auto'>
          <div>
            {additionalActionRow()}
          </div>
          <button
            type='button'
            disabled={isActive || isUpcoming}
            onClick={() => handlePlanSelect(plan.subscriptionId, plan.name)}
            className={`tw-border tw-w-full tw-py-3 tw-px-6 tw-rounded-2xl tw-font-medium tw-transition-all tw-duration-200 tw-transform tw-hover:tw-scale-105 tw-active:tw-scale-95 ${
                isSelected
                ? activePlan != undefined ? altStyle2 : altStyle1
                : activePlan != undefined && isActive ? isIssueStatus ? issueStyle : altStyle1 : isUpcoming ? altStyle2 :selectStyle
            }`}
            
            style={{
                border: '1px solid transparent'
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanCard